import styled from '@emotion/styled';
import { TableCell, TableContainer, TableRow } from '@mui/material';
import { createGlobalStyle } from 'styled-components';



export const styles = {

  descBox: {
    bgcolor: '#ffffff',
    width: '100%',
    height: '70vh',
    boxShadow: '0px 5.6px 11.2px 0px rgba(0,0,0,0.15)',
    fontFamily: 'MuseoSans',
    margin: '5px 0px 0px 20px',
    padding: '24px',
    overflow:'auto',
    '::-webkit-scrollbar': {
      width:'10px',
      
    
    
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#a8abac', 
    borderRadius: '16px', 
    height:'45px',
    
  },
  '@media (max-width: 1200px)':{
    height:'auto'
   }
  
  },
  

  sidebar: {
    width: '239px',
    background: '#ffffff',
    position: 'sticky',
    top: '44px',
    bottom: '10',
    marginTop: '5px',
    height: 'auto',
    overflowY: 'auto',
    boxShadow: '0px 5.6px 11.2px 0px rgba(0,0,0,0.15)',
    padding: '16px',
    textDecoration: 'none',
    
  },

  sidebarList: {
    listStyle: 'none',
    padding: '0px',
    margin: '0',
    
  },

  bottomNavBar: {
    position: 'fixed',
    bottom: '0',
    left: '0',
    width: '100%',
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'space-around',
    padding: '10px 0',
    zIndex: '10',
    textDecoration: 'none',
    overflowX: 'scroll',
    transition: 'background 0.5s ease',
    whiteSpace: 'nowrap',
  },


  bottomNavBarItem: (isActive) => ({
    padding:'0px 10px 0px 20px',
    cursor: 'pointer',
    color: '#0B71A2',
    fontWeight: isActive ? 'bold' : '100',
    background: 'transparent',
    border: 'none',
    fontSize: '16px',
    listStyle: 'none',
    whiteSpace: 'nowrap',
    fontFamily: 'MuseoSans',
  }),

  sidebarItem: (isActive) => ({
    display:'flex',
    flexDirection:'column',
    padding: '8px 16px 8px 16px',
    cursor: 'pointer',
    color: '#0B71A2',
    fontWeight: isActive ? 'bold' : '100',
    transition: 'background 0.5s ease',
    lineHeight: '24px',
    background: 'transparent',
    border: 'none',
    fontFamily: 'MuseoSans',
    
  }),
  container: {
    display:'flex',
    flex:1,
    height: '80vh',
    padding: '24px',
    paddingBottom: '0px',
  },
  
  boldTableHeaders: {
    fontWeight:'bold',
  },
  

};

export const StyledH3 = styled('h3')({
  color: '#529535',
  fontFamily: 'MuseoSans',
  fontweight: 700,
  margin: '20px 0px 20px 0px',
  lineHeight: '31.6702px',
  padding: '0px 0px 0px 0px',
  fontSize: 'clamp(23px, 2vw + 0.1rem, 28px)',
  overflowWrap: 'break-word',
});

export const StyledH4 = styled('h4')(({theme})=>({
  color: '#529535',
  fontFamily: 'MuseoSans',
  fontWeight: 400,
  margin: '20px 0px 16px 0px',
  lineHeight: '31.6702px',
  padding: '0px 0px 0px 0px',
  fontSize: 'clamp(20px, 2vw + 0.1rem, 23px)',
  overflowWrap: 'break-word',
}));

export const StyledList = styled('li')({
  color: '#474B55',
  fontSize: '16px',
  fontFamily: 'MuseoSans',
  fontWeight: 300,
  lineHeight: '24px',
  margin: '0px',
  overflowWrap: 'break-word',
});

export const StyledPTag = styled('p')({
  color: '#474B55',
  fontSize: '16px',
  fontFamily: 'MuseoSans',
  fontWeight: 300,
  lineHeight: '24px',
  margin: '10px 0px 16px 0px',
  padding: '0px 0px 0px 0px',
  whiteSpace: 'pre-line',
  overflowWrap: 'break-word',
});

export const StyledTable = styled(TableContainer)({
  padding: '0px 0px 11px 0px',
  overflowX: 'auto',
  overflowY: 'hidden',
  '&::-webkit-scrollbar': {
    height:'8px',
    
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#f7f5f5',
    borderRadius:'4px',
    border: '1px solid black',
    
  }
})

export const StyledBoldText = styled('span')({
  fontWeight:'bold'
})

export const StyledCell = styled(TableCell)({
  border: '1px solid #f1f2f3',
  color: '#474B55',
  
  
})

export const StyledRow = styled(TableRow)({
  border: '1px solid #f1f2f3',
  color: '#474B55',
  
  
})

export const StyledATag = styled('a')({
  color: '#0B71A2',
  '&:hover': {
    color: '#529535'
  },
  overflowWrap: 'break-word',
  
})

export const StyledHeader = styled('h3')(({theme}) => ({
    color: '#529535',
    fontSize: 'clamp(30px, 2vw + 0.1rem, 39px)',
    fontFamily: 'MuseoSans',
    fontWeight: 700,
    padding: '0px 10px 0px 0px',
    lineHeight: '31.6702px',
    overflowWrap: 'break-word',
}));

export const Global = createGlobalStyle`
/* body::-webkit-scrollbar {
  width:10px;
}
body::-webkit-scrollbar-thumb {
  background-color: #f7f5f5;
  border-radius:4px;
  border: 1px solid black;
} */
`